<mat-card appearance="outlined">
    <ng-container *ngIf="ready">
        <ng-container *ngIf="error">
            <p class="text-center"><strong>Error</strong></p>
            <span *ngFor="let card of errors; trackBy: trackByIndex">
                <p class="text-center">{{card}}</p>
            </span>
            <div class="text-center">
                <button mat-stroked-button (click)="closeDialog()">
                    <mat-icon>close</mat-icon>
                    Cerrar
                </button>
            </div>
        </ng-container>
        <ng-container *ngIf="error == false">
            <div class="row">
                <div class="col">
                    <p class="text-center" style="color: red"><strong>ADVERTENCIA</strong></p>
                    <p class="text-center">
                        Antes de continuar, debe comprobar si las cuentas bancarias de los contactos asociados a las
                        Facturas
                        seleccionadas tienen marcada su cuenta bancaria como <strong>POR DEFECTO DOMILIACIÓN
                            BANCARIA</strong>.
                        Puede
                        comprobar dicha información en la sección Cuentas Bancarias dentro del Contacto.
                    </p>
                    <p class="text-center">Por el contrario, si no se han marcado, <strong>se seleccionará la
                            primera
                            cuenta
                            bancaria que disponga
                            el contacto</strong>.
                    </p>
                    <div class="d-flex justify-content-center flex-column flex-md-row">
                        <ng-container *ngIf="!working">
                            <button mat-stroked-button (click)="remesa()"
                                class="me-0 me-md-2 mb-2 mb-md-0 color-factuone">Lo
                                entiendo</button>
                        </ng-container>
                        <ng-container *ngIf="working">
                            <div class="cf-dlg-loading"><div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div></div>
                        </ng-container>
                        <button mat-stroked-button (click)="closeDialog()">
                            <mat-icon>close</mat-icon>
                            Cerrar
                        </button>
                    </div>
                    <div *ngIf="errors && errors.length > 0" class="error-box">
                        <h3>Errores encontrados:</h3>
                        <ul>
                            <li *ngFor="let err of errors; trackBy: trackByIndex">{{ err }}</li>
                        </ul>
                    </div>
                </div>
            </div>
        </ng-container>
    </ng-container>
    <ng-container *ngIf="!ready">
        <div class="cf-dlg-loading"><div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div></div>
    </ng-container>
</mat-card>